/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityContext } from './EntityContext';
import {
    EntityContextFromJSON,
    EntityContextFromJSONTyped,
    EntityContextToJSON,
    EntityContextToJSONTyped,
} from './EntityContext';

/**
 * 
 * @export
 * @interface CaseEntity
 */
export interface CaseEntity {
    /**
     * 
     * @type {string}
     * @memberof CaseEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEntity
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEntity
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEntity
     */
    confidence?: number;
    /**
     * 
     * @type {EntityContext}
     * @memberof CaseEntity
     */
    context?: EntityContext;
    /**
     * 
     * @type {string}
     * @memberof CaseEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEntity
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {any}
     * @memberof CaseEntity
     */
    securityCase?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseEntity
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseEntity
     */
    updated?: Date;
}

/**
 * Check if a given object implements the CaseEntity interface.
 */
export function instanceOfCaseEntity(value: object): value is CaseEntity {
    return true;
}

export function CaseEntityFromJSON(json: any): CaseEntity {
    return CaseEntityFromJSONTyped(json, false);
}

export function CaseEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'context': json['context'] == null ? undefined : EntityContextFromJSON(json['context']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'securityCase': json['securityCase'] == null ? undefined : json['securityCase'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function CaseEntityToJSON(json: any): CaseEntity {
    return CaseEntityToJSONTyped(json, false);
}

export function CaseEntityToJSONTyped(value?: CaseEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'value': value['value'],
        'confidence': value['confidence'],
        'context': EntityContextToJSON(value['context']),
        'tenantId': value['tenantId'],
        'assetGoldenId': value['assetGoldenId'],
        'securityCase': value['securityCase'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

